/**
 * History of last visited lists and profiles
 *
 * Items must match the search result structure:
 * {
 * 	"item_id":			"1407",
 * 	"name":				"Griechenland",
 * 	"label":			"<strong>Griechenland</strong>",
 * 	"link":				"/griechenland",
 * 	"type":				"country",
 * 	"type_label":		"Land",
 * 	"geo_paths":		[],
 * 	"hotels_number":	"278"
 * 	"is_alternative":	false
 * }
 */

const STORAGE_KEY = "search-history";
const MAX_LENGTH = 8;

let history = null;
try {
	history = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
} catch {
	history = [];
}

export const add = newItem => {
	// Remove new item from history if it was already there.
	history = history.filter(item => item.link !== newItem.link);

	// Add new item a the beginning and cap the history at MAX_LENGTH items.
	history = [newItem, ...history].slice(0, MAX_LENGTH);

	// Update local storage.
	localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
};

export const get = () => history;
